import { useEffect, useState } from 'react'
import useSidebarLinks from '@/hooks/sidebarMenu/useSidebarLinks'
import { useMedia } from '@/hooks/useMedia'
import { NavHeader, SplitControlledMenuItem } from './components'
import { SidebarMenuItem } from '@/resources/types'
import * as S from './styles'

const SidebarMenu = () => {
  const isMobile = useMedia(['(max-width: 768px)'], [true], false)
  const [opened, setOpened] = useState(false)
  const { isReady, links } = useSidebarLinks()

  const toggleOpened = (open: boolean) => {
    if (isMobile) setOpened(open)
  }

  useEffect(() => {
    if (!isMobile && opened) setOpened(false)
  }, [isMobile, opened])

  return (
    <S.Nav className="hidden-print">
      <NavHeader opened={opened} onClick={toggleOpened} />
      {isReady && (
        <S.Content data-opened={opened} data-testid="sidebar-menu-content">
          {links.map((link: SidebarMenuItem) => (
            <SplitControlledMenuItem
              menuItem={link}
              key={`menu-item-${link.id}`}
              onClick={() => toggleOpened(false)}
            />
          ))}
        </S.Content>
      )}
    </S.Nav>
  )
}

export default SidebarMenu
